import { render, staticRenderFns } from "./QueryViewPage.vue?vue&type=template&id=71d44c40&scoped=true&"
import script from "./QueryViewPage.vue?vue&type=script&lang=js&"
export * from "./QueryViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d44c40",
  null
  
)

export default component.exports